export class TokenExpiredError implements Error {
  name = 'TokenExpiredError';

  constructor(
    public message: string,
    public stack?: string
  ) {}
}
